import { AxiosRequestConfig } from "axios"
import HTTPRequest from "../HTTPRequest.js"
import type { HTTPRequestBody } from "../HTTPRequestBody.js"

/**
 * @description
 *	Maps from an HTTP immutable request to an Axios request configuration.
 */
const HTTPRequestToAxiosRequestConfiguration = <I>(request: HTTPRequest<I>): AxiosRequestConfig<HTTPRequestBody> => {
	return {
		adapter: undefined,
		auth: undefined,
		baseURL: undefined,
		cancelToken: undefined,
		data: request.body,
		decompress: true,
		headers: request.headers,
		httpAgent: undefined,
		httpsAgent: undefined,
		maxBodyLength: undefined,
		maxContentLength: undefined,
		maxRedirects: 0,
		method: request.method.toLowerCase(),
		onDownloadProgress: undefined,
		onUploadProgress: undefined,
		params: undefined,
		paramsSerializer: undefined,
		proxy: false,
		responseEncoding: "UTF-8",
		responseType: "json",
		signal: undefined,
		socketPath: undefined,
		timeout: request.timeoutInMilliseconds,
		transformRequest: undefined,
		transformResponse: undefined,
		url: request.uri.href,
		validateStatus: (status: number) => 100 <= status && status < 400,
		withCredentials: false,
		xsrfCookieName: undefined,
		xsrfHeaderName: undefined
	}
}

export default HTTPRequestToAxiosRequestConfiguration
